import React,{useState, useEffect} from 'react';
import hero from '../../Images/h1.jpeg';

export default function About(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);

        return () =>window.removeEventListener("scroll", handleScroll);
    },[])
    
    if(media.matches){
        return(
            <div className="about">
                <div className="hero-sec">
                    <div className="hero-base" data-aos="fade-up">
                        <img src={hero} className="hero-img" />
                    </div>
                </div>
                <div className="text-sec">
                    <div className="text-base" data-aos="fade-right">
                        <h2 className="about-head">Who am I?</h2>
                        <h2 className="about-head">We all have a story to tell.</h2>
                        <p className="about-para">My journey from an student to developer to designer while trying, tackling, improving many things on the way.</p>
                        <a href="/story"><button className="social-btn">Read My Story</button></a>
                    </div>
                </div>
            </div>
        )}
    else{
        return (
            <div className="about">
                <div className="hero-sec">
                    <div className="hero-base">
                        <img src={hero} className="hero-img" />
                    </div>
                </div>
                <div className="text-sec">
                    <div className="text-base">
                        <h2 className="about-head">Who am I?</h2>
                        <h2 className="about-head">We all have a story to tell.</h2>
                        <p className="about-para">My journey from an student to developer to designer while trying, tackling, improving many things on the way.</p>
                        <a href="/story"><button className="social-btn">Read My Story</button></a>
                    </div>
                </div>
            </div>
        )}
}